require('./_drawer.scss')

const Drawer = {

  init: function (element) {
    const _ = this
    _.el = element
    _.items = this.el.querySelectorAll('.drawer__item-button')

    for (const item of this.items) {
      item.addEventListener('click', (e) => {
        _.item_click(e.currentTarget, _)
      }, false)
    }
  },

  item_click: (target, _) => {
    const parent = target.parentNode
    if (parent.classList.contains('active')) {
      _.item_hide(parent)
    } else {
      _.item_show(parent)
    }
  },

  item_show: (target) => {
    target.classList.add('active')
    const button = target.querySelector('button')
    const drawer = target.querySelector('.drawer__item-drawer')
    button.attributes['aria-expanded'].value = true
    drawer.attributes['aria-hidden'].value = false
  },

  item_hide: (target) => {
    target.classList.remove('active')
    const button = target.querySelector('button')
    const drawer = target.querySelector('.drawer__item-drawer')
    button.attributes['aria-expanded'].value = false
    drawer.attributes['aria-hidden'].value = true
  }
}

export default Drawer
